import CreatePasswordView from './CreatePasswordView'
export default CreatePasswordView
